// Lightweight profile store (localStorage)
export const PROFILE_KEY = "sne_profile";
// Pro athletes ONLY: identity lock — these fields are frozen after the first
// onboarding so that one access code cannot be re-used to generate plans for
// many different people (multi-device fraud). Lifestyle profiles are exempt
// (family members can each onboard differently).
export const IDENTITY_LOCK_KEY = "sne_identity_lock";
const LOCKED_FIELDS = ["name", "sex", "age", "sport", "position"];

export const saveProfile = (profile, opts = {}) => {
  localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
  // Persist the identity lock the first time a Pro profile is saved.
  // `opts.skipLock` (service mode) explicitly skips persistence so the owner
  // can iterate freely with `!iulserv@`.
  if (
    !opts.skipLock &&
    profile?.profile_type === "pro" &&
    !localStorage.getItem(IDENTITY_LOCK_KEY)
  ) {
    const locked = {};
    LOCKED_FIELDS.forEach((k) => { if (profile[k] !== undefined) locked[k] = profile[k]; });
    locked.profile_type = "pro";
    localStorage.setItem(IDENTITY_LOCK_KEY, JSON.stringify(locked));
  }
};
export const loadProfile = () => {
  try { return JSON.parse(localStorage.getItem(PROFILE_KEY) || "null"); } catch { return null; }
};
export const loadIdentityLock = () => {
  try { return JSON.parse(localStorage.getItem(IDENTITY_LOCK_KEY) || "null"); } catch { return null; }
};
export const clearIdentityLock = () => localStorage.removeItem(IDENTITY_LOCK_KEY);
export const clearProfile = () => localStorage.removeItem(PROFILE_KEY);
export { LOCKED_FIELDS };
